module.exports = __webpack_public_path__ + "img/wifi.13c5cb8b.png";